import { ContentIntro } from './content/intro';

/**
 * Model definition for app-button
 */
export interface AppButton {
  __contentType: 'app-button';
  id: string;
  name?: string;
  intro?: ContentIntro;
  appStoreUrl?: string;
  googlePlayUrl?: string;
}

export function isAppButton(obj: { __contentType?: string }): obj is AppButton {
  return obj.__contentType === 'app-button';
}
